import { countriesQuery } from "@/api/location";
import { supplierQuery } from "@/api/supplier";
import { availableMarketsQuery, registeredMarketsQuery } from "@/api/supplierMarkets";
import { queryClient } from "@/api/utils";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/markets")({
  loader: ({ params: { supplierId } }) => {
    queryClient.prefetchQuery(supplierQuery(supplierId));
    queryClient.prefetchQuery(registeredMarketsQuery(supplierId));
    queryClient.prefetchQuery(availableMarketsQuery);
    queryClient.prefetchQuery(countriesQuery(false));
  },
  component: lazyRouteComponent(() => import("./+Markets")),
  head: () => ({
    meta: seo({ title: "Markets" }),
  }),
});
